import AddEditTemplateSchedule from './AddEditTemplateSchedule';

export default AddEditTemplateSchedule;
